import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import Button from '@hero/ui-kit/inputs/Button';
import { useReactivationFlowContext } from '../context/ReactivationFlowProvider';
import useComponentMargin from '@hero/ui-kit/hooks/useComponentMargin';
import P from '@hero/ui-kit/typography/P';

export const Success = () => {
    const { onCloseReactivationFlow, successDetails } = useReactivationFlowContext();
    const marginTop = useComponentMargin({ marginTop: 'large' });

    return (
        <>
            <H role="h6" centered>
                Success! Membership Reactivated
            </H>
            <Section
                noDefaultPadding
                styles={{ textAlign: 'left', ...marginTop }}
                width="full"
                centered
            >
                <ul>
                    {successDetails.list.map((message, index) => (
                        <li key={`${index}-${message}`}>
                            <P size="large" strong>
                                {message}
                            </P>
                        </li>
                    ))}
                </ul>
            </Section>
            <Section centered>
                <Button width="large" onClick={onCloseReactivationFlow}>
                    Return to Membership Details
                </Button>
            </Section>
        </>
    );
};
